/**
 * Constants for the Partners side of the Referral Program.
 * Mirrors the spec in Confluence "Partners - Web Admin" and the backend
 * /admin/partner-referral-wl APIs.
 */

/** Whitelist record status. Values match the backend status update API. */
export enum PartnerReferralStatus {
  ACTIVE = 1,
  DEACTIVATED = 2,
  DELETE = 3,
}

/** Reward token enum used by the partner reward-config API (PUT /reward-config/:ptoId). */
export const PARTNER_REWARD_TOKEN_OPTIONS = [
  { value: 1, label: 'MEY' },
  { value: 2, label: 'USDC' },
  { value: 3, label: 'USDT' },
  { value: 4, label: 'ETH' },
]

export const getPartnerRewardTokenLabel = (value?: number) =>
  PARTNER_REWARD_TOKEN_OPTIONS.find((opt) => opt.value === value)?.label ?? 'MEY'

/** Whitelist file upload constraints. */
export const PARTNER_WHITELIST_MAX_SIZE_MB = 10
export const PARTNER_WHITELIST_ACCEPT = '.csv,.xlsx,.xls'
export const PARTNER_WHITELIST_ALLOWED_EXTENSIONS = ['csv', 'xlsx', 'xls']

/** Search box max length per spec. */
export const PARTNER_SEARCH_MAX_LENGTH = 255

/** Whitelist CSV template (one `walletAddress` column, one address per line). */
export const PARTNER_WHITELIST_TEMPLATE_FILENAME = 'partner_whitelist_template.csv'
export const PARTNER_WHITELIST_TEMPLATE_HEADER = 'walletAddress'
export const PARTNER_WHITELIST_TEMPLATE_SAMPLE_ADDRESSES = [
  '0xe6c88d91379b66c144deec1d5ef2022ea443e6e9',
  '0xea0cb8bef7cb23a006b0b40f2cde619706e5b961',
  '0x790d9361a0680d31372d9ef1d7b14de339452ea1',
  '0xcc8d8cca865825a2a49b22be42c1a18a928fba8c',
]

/** Messages from the Confluence spec (section 4). */
export const PARTNER_REFERRAL_MESSAGES = {
  E01: 'File type must be CSV, XLSX, XLS',
  E02: 'File size cannot be greater than 10MB',
  S01: 'Partner deactivated',
  S02: 'Partner reactivated',
  S03: 'Wallet address removed',
}
